import { addToChainAfter, Handler } from "@insite/client-framework/HandlerCreator";
import { chain, FireOnSuccess } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";

type HandlerType = Handler<any, any>;

export const DeleteLocalStorage: HandlerType = props => {
    window?.localStorage?.removeItem("selectedWarehouseForInventory");
};

addToChainAfter(chain, FireOnSuccess, DeleteLocalStorage);
